<script>
    import { Pie } from 'vue-chartjs'

    export default {
        extends: Pie,
        props: ['chartdata', 'options','dataname','piecolor'],
        mounted () {
            Chart.defaults.global.legend.display = true;
            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: this.piecolor,
                        data: this.options,
                    }
                ]
            }, { responsive: true, maintainAspectRatio: false })
        }
    }
</script>

<style scoped>

    * {
        font-size: 13px;
    }

</style>
